<template>
  <div>
    <Card>
      <Form
        :model="formItem"
        :disabled="prevent"
        :label-width="labelWidth"
        label-position="left"
        style="margin-top: 20px"
      >
        <Row :gutter="38">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Name')"
              ><!-- 姓名 -->
              <Input v-model="formItem.userName" clearable />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Employee_Code')"
              ><!-- 工号 -->
              <Input v-model="formItem.empCode" clearable />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')" style="margin-bottom: 0"
              ><!-- 直接主管 -->
              <Input
                v-model="formItem.dirSupUserName"
                search
                enter-button
                clearable
                readonly
                @on-clear="dirClear()"
                @on-search="dirSearch"
              />
            </FormItem>
            <p style="font-size: 12px; color: red">
              <!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 -->
              {{ $t("PB_longText31") }}
            </p>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Reporting_Line')"
              ><!-- 汇报层级 -->
              <Select
                v-model="formItem.levelNum"
                multiple
                clearable
                :disabled="levelDisabledState"
              >
                <Option
                  v-for="item in Level"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('BU')"
              ><!-- 业务单元 -->
              <Select v-model="formItem.businessUnit" clearable>
                <Option
                  v-for="item in businessUnitList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Department')"
              ><!-- 大区 -->
              <Select v-model="formItem.department" clearable>
                <Option
                  v-for="item in departmentList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Funciton')"
              ><!-- 职能 -->
              <Select v-model="formItem.postFun" clearable>
                <Option
                  v-for="item in functionList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('DepartmentSalesRegion')"
              ><!-- 部门/销售区域 -->
              <Select v-model="formItem.salesArea" clearable>
                <Option
                  v-for="item in salesAreaList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Position')"
              ><!-- 职位 -->
              <!-- <Select v-model="formItem.position" clearable>
                                <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{ item.ch_value }}</Option>
                            </Select> -->
              <Input v-model="formItem.position" clearable></Input>
            </FormItem>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="6"
            v-if="fileHidden && !hideKeys.includes('year')"
          >
            <FormItem :label="$t('Year')"
              ><!-- 年度 -->
              <DatePicker
                type="year"
                v-model="formItem.year"
                style="width: 100%"
                clearable
                :disabled="disKeys.includes('year')"
                @on-change="onFormChange('year')"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6" v-if="fileHidden">
            <FormItem :label="$t('PersonelType2')"
              ><!-- personneltype2 -->
              <Select v-model="formItem.personnelType" clearable>
                <Option
                  v-for="item in personnelType"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('IsNotSTIEmp')"
              ><!-- 是否有STI -->
              <Select v-model="formItem.perresult" clearable>
                <Option
                  v-for="item in YesOrNo"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="6"
            v-if="!hideKeys.includes('beQuit')"
          >
            <FormItem :label="$t('PB_Employment_Status')"
              ><!-- 是否有STI -->
              <Select v-model="formItem.beQuit" clearable>
                <Option
                  v-for="item in BeQuit"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <slot name="slot1" :formItem="formItem"></slot>
          <slot name="slot2" :formItem="formItem"></slot>
          <slot name="slot3" :formItem="formItem"></slot>
          <slot name="slot4" :formItem="formItem"></slot>
          <slot name="slot5" :formItem="formItem"></slot>
          <slot name="slot6" :formItem="formItem"></slot>
          <slot name="slot7" :formItem="formItem"></slot>
          <slot name="slot8" :formItem="formItem"></slot>
          <slot name="slot9" :formItem="formItem"></slot>
          <slot name="slot10" :formItem="formItem"></slot>
          <slot name="slot11" :formItem="formItem"></slot>
          <slot name="slot12" :formItem="formItem"></slot>
          <slot name="slot13" :formItem="formItem"></slot>
          <slot name="slot14" :formItem="formItem"></slot>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('GroupSelect')">
              <UserGroupList
                ref="UserGroupList"
                @confirmSelectGroup="confirmSelectGroup"
              ></UserGroupList>
            </FormItem>
          </Col>
          <slot name="slot15" :formItem="formItem"></slot>
          <slot name="slot16" :formItem="formItem"></slot>
          <Col span="4">
            <Button type="primary" @click="search()"
              ><!-- 检索 -->{{ $t("Search") }}</Button
            >
            <Button @click="handleReset()"
              ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
            >
          </Col>
        </Row>
        <!-- <Row type="flex" justify="end">
                    
                </Row> -->
      </Form>
    </Card>
    <DirModalComponent
      ref="DirModalComponent"
      @selectRow="dirSelect"
    ></DirModalComponent>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
import DirModalComponent from "./modalComponents/DirModalComponent";
import UserGroupList from "./UserGroupList.vue";
export default {
  // props:['searchFormItem','labelWidth','fileHidden'],
  props: {
    searchFormItem: Object,
    labelWidth: Number,
    fileHidden: {
      type: Boolean,
      default: true,
    },
    disKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    hideKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: { DirModalComponent, UserGroupList },
  data() {
    return {
      date: new DateUtil(),
      prevent: false,
      formItem: {
        year: "",
        dirSupUserName: "",
        levelNum: [],
      },
      selectList: [],
      positionList: [], //职位
      ApplyStatus: [], //状态
      departmentList: [], //部门
      businessUnitList: [], //业务单元
      Level: [],
      functionList: [],
      personnelType: [],
      salesAreaList: [], //销售区域
      YesOrNo: [], //是否
      BeQuit: [], //在职状态
      levelDisabledState: false,
      levelDisabled: false,
      pShow: false,
    };
  },
  computed: {
    formItema() {
      return { ...this.searchFormItem, ...this.formItem };
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    this.formItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
    // this.getListData()
  },
  methods: {
    dirSearch() {
      this.$refs.DirModalComponent.modalShow = true;
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          // 销售区域

          this.businessUnitList = res.businessUnitList;
          this.Level = res.Level;
          this.personnelType = res.personnelType;
        }
      });
    },
    // 组选择
    confirmSelectGroup(list) {
      this.formItem.userGroupList = JSON.parse(JSON.stringify(list));
    },
    dirSelect(item) {
      let json = JSON.parse(item);
      this.formItem.dirSupUserName = json.userName;
      this.formItem.dirSupSerialnumber = json.dirSupSerialnumber;
      this.$set(this.formItem, "dirSupUserName", json.userName);
      this.levelDisabledState = false;
    },
    search() {
      // this.formItem={...this.formItem,...this.searchFormItem}
      this.prevent = true;
      this.formItem.year = this.date.dateVal(this.formItema.year, "YYYY");
      let formItemSub = { ...this.searchFormItem, ...this.formItem };
      this.$emit("searchForm", JSON.stringify(formItemSub));
    },
    dirClear() {
      this.formItem.dirSupSerialnumber = "";
      this.levelDisabled ? (this.levelDisabledState = true) : "";
    },
    handleReset() {
      this.formItem = {
        year: JSON.parse(sessionStorage.getItem("userInfo")).year,
        dirSupUserName: "",
        levelNum: [],
      };
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.formItem.userGroupList = [];
      this.formItem = { ...this.formItem };
      this.$emit("handleReset", JSON.stringify(this.formItem));
    },
    onFormChange(key) {
      this.$emit('onFormChange',{
        key:key,
        value:this.formItem[key]
        })
    }
  },
};
</script>

<style lang="less">
.ivu-select-multiple .ivu-select-item {
  padding-left: 40px !important;
}
.ivu-select-multiple .ivu-select-item::after {
  width: 22px !important;
  height: 22px;
  border: 1px solid #cccccc !important;
  border-radius: 3px !important;
  display: inline-block !important;
  font-family: "Ionicons" !important;
  speak: none !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: optimizeLegibility;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: -0.125em;
  text-align: center;
  font-size: 22px;
  content: "";
  color: rgba(69, 152, 70, 0.9);
  position: absolute !important;
  top: 4px !important;
  left: 4px !important;
}
.ivu-select-multiple .ivu-select-item-selected:after {
  width: 22px !important;
  height: 22px;
  border: 1px solid #cccccc !important;
  border-radius: 3px !important;
  display: inline-block !important;
  font-family: "Ionicons" !important;
  speak: none !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: optimizeLegibility;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: -0.125em;
  text-align: center;
  font-size: 22px;
  content: "\F171";
  color: #fff;
  background: rgba(69, 152, 70, 0.9);
  position: absolute !important;
  top: 4px !important;
  left: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/FormComponent.vue